var window_size = screen.width;
jQuery(document).ready(function(){
  
  
  jQuery('.page-tabs li a').click(function(){
    var tab_id = $(this).attr('data-tab');

    jQuery('.page-tabs a').removeClass('current');
    jQuery('.tab-content').removeClass('current');

    jQuery(this).addClass('current');
    jQuery("#"+tab_id).addClass('current');
    return false;
  });
  
  $('.close').click(function(){
$('.pop').hide();
//   $('.overlay').hide();

return false;
});
  
  jQuery('.popup-youtube').on("click", function(){
    	var vurlid = jQuery(this).attr("simix-videourl");
    	var videoURL = "https://player.vimeo.com/video/"+vurlid+"?h=bea570d01e&autoplay=1&title=0&byline=0&portrait=0";
    	jQuery("#simixviframe").attr("src", videoURL);
    	jQuery(".simix-videoshowpopup-overly-wr, .simix-videoshowpopup-wr").fadeIn();
  });

  jQuery('.popup-youtube-embed').on("click", function(){
    	var videoURL = jQuery(this).attr("simix-videourl");
    	jQuery("#simixviframe").attr("src", videoURL);
    	jQuery(".simix-videoshowpopup-overly-wr, .simix-videoshowpopup-wr").fadeIn();
  });

  $('.simix-videoshowpopup-overly-wr').click(function(){
    $('.simix-videoshowpopup-overly-wr').fadeOut();
    $('.simix-videoshowpopup-wr').fadeOut();
    jQuery("#simixviframe").attr("src", "");

  });
  
  $('.Team-content .comn-btn').click(function(){
    var dataId = $(this).attr("data-id");
    $("#" + dataId).css("display", "block");
    $("#" + dataId + ' .popup' ).css("display", "block");
  });
  
  $('.roof-type .comn-btn').click(function(){
    var dataId = $(this).attr("data-id");
    $("#" + dataId).css("display", "block");
    $("#" + dataId + ' .popup' ).css("display", "block");
  });
  
  $('.apply-btn-wr .comn-btn').click(function(){
    var dataId = $(this).attr("data-id");
    $("#" + dataId).css("display", "block");
    $("#" + dataId + ' .popup' ).css("display", "block");
  });
  
  jQuery('.ac-slider').bxSlider({
        controls: true,
        infiniteLoop: true,
        pager: false,
        touchEnabled: false,
        auto: false,
        slideWidth:1200,
        slideMargin:70,
        minSlides:1,
        maxSlides:1,
        moveSlides:1,
        adaptiveHeight: true
  });
  
  if(window_size <= 479){
    jQuery('.testimonial-image-slider').bxSlider({
      auto: true,
      touchEnabled: false,
      controls: false,
      pager: false,
      maxSlides: 1,
      minSlides: 1,
      moveSlides: 1,
      speed: 1000
    });
  }
  else if(window_size <= 650){
    jQuery('.testimonial-image-slider').bxSlider({
      auto: true,
      touchEnabled: false,
      controls: false,
      pager: false,
      slideWidth: 300,
      slideMargin:25,
      maxSlides: 2,
      minSlides: 2,
      moveSlides: 1,
      speed: 1000
    });
  }
  else if(window_size <= 768){
    jQuery('.testimonial-image-slider').bxSlider({
      auto: true,
      touchEnabled: false,
      controls: false,
      pager: false,
      slideWidth: 220,
      slideMargin:30,
      maxSlides: 3,
      minSlides: 3,
      moveSlides: 1,
      speed: 1000
    });
  }
  else{
    jQuery('.testimonial-image-slider').bxSlider({
      auto: true,
      touchEnabled: true,
      controls: false,
      pager: false,
      slideWidth: 280,
      slideMargin:20,
      maxSlides: 4,
      minSlides: 4,
      moveSlides: 3,
      speed: 1000
    });
  }

  var numItems = $('.video_container').length

  if(numItems > 3){
    if(window_size <= 650){
        jQuery('.video_gallery_slider').bxSlider({
          auto: true,
          touchEnabled: true,
          controls: false,
          pager: false,
          slideWidth: 420,
          maxSlides: 1,
          minSlides: 1,
          moveSlides: 1,
          speed: 1000
        });
    } else if(window_size <= 1024){
        jQuery('.video_gallery_slider').bxSlider({
          auto: true,
          touchEnabled: true,
          controls: false,
          pager: false,
          slideWidth: 412,
          slideMargin:15,
          maxSlides: 2,
          minSlides: 2,
          moveSlides: 1,
          speed: 2000
        });
    }else{
      jQuery('.video_gallery_slider').bxSlider({
        auto: true,
        touchEnabled: true,
        controls: false,
        pager: false,
        slideWidth: 415,
        slideMargin:30,
        maxSlides: 3,
        minSlides: 3,
        moveSlides: 1,
        speed: 2000
      });
    }
  }else{
     if(window_size <= 650){
        jQuery('.video_gallery_slider').bxSlider({
          auto: true,
          touchEnabled: true,
          controls: false,
          pager: false,
          slideWidth: 420,
          maxSlides: 1,
          minSlides: 1,
          moveSlides: 1,
          speed: 1000
        });
    } else if(window_size <= 1024){
        jQuery('.video_gallery_slider').bxSlider({
          auto: true,
          touchEnabled: true,
          controls: false,
          pager: false,
          slideWidth: 412,
          slideMargin:15,
          maxSlides: 2,
          minSlides: 2,
          moveSlides: 1,
          speed: 2000
        });
    }
  }
  
function getUrlVars(){
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

  var id = getUrlVars()["scid"];
  console.log(id);
  
  var totalOptions = $('.product-variants option').length;
  console.log(totalOptions);
  $('.product-variants').data( 'min', 'totalOptions' );

  $('html,body').animate({scrollTop: $("div#" + id).offset().top -200 }, 500);
  
  
});

if(window_size > 360){
	window.onscroll = function() {
      myFunction()
    };
}

// Get the offset position of the navbar
// var stickyOffset = $('#shopify-section-header').offset().top;
// console.log(stickyOffset);

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  var sticky = $('#shopify-section-header'),
      scroll = $(window).scrollTop();

  if (scroll >= 174) sticky.addClass('simixsticky-fixed');
  else sticky.removeClass('simixsticky-fixed');
}

            

new WOW().init();